import {
  Autocomplete,
  Button,
  CircularProgress,
  DialogActions,
  DialogTitle,
  FormHelperText,
  Grid,
  Modal,
  TextField,
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import { QuillEditor } from 'src/sections/dashboard/patients/quill-editor';
import * as Yup from 'yup';
import { usePageView } from 'src/hooks/use-page-view';
import { useDispatch, useSelector } from 'react-redux';
import { GET_PATIENT_RECORD, getAllPatientAction } from 'src/redux/actions/patientAction';
import { useFormik } from 'formik';
import {
  addTaskToTherapist,
  getAllTaskTypeAction,
  resetAddNewTaskTherapist,
} from 'src/redux/actions/taskTypeAction';
import moment from 'moment';
import SucessModal from 'src/components/sucess-modal';
import useCurrentUser from 'src/hooks/use-current-user';

type Props = {
  handleCloseAddTaskForm: any;
  currentTab: string;
  date: string;
  selectedTaskType?: string;
};

const AddTaskForm = (props: Props) => {
  const [searchName, setSearchName] = useState('');
  const [intervalTime, setIntervalTime] = useState<NodeJS.Timer | null>(null);
  const [searchDefaultValue, setSearchDefaultValue] = useState('');
  const [error, setError] = useState('');
  usePageView();
  const dispatch = useDispatch();
  const { handleCloseAddTaskForm, currentTab } = props;
  const [pageNo, setPageNo] = useState(0);
  const getAllPatients = useSelector((state: any) => state.getPatientReducer?.response);
  const gettingPatientList = useSelector((state: any) => state.getPatientReducer);
  const [providerId] = useCurrentUser(['providerId']);
  const taskType = useSelector((state: any) => state.getAllTherapistTaskTypeReducer?.data);
  const isTaskAdded = useSelector((state: any) => state.AddTaskToTherapistReducer);
  const validationSchema = Yup.object().shape({
    patientId: Yup.string().required('Please enter valid Patient Name'),
    tasksType: Yup.string().required('Please enter valid Task'),
    numberOfMinutes: Yup.number()
      .required('Please enter valid Number of Minutes')
      .positive('Please enter valid Number of Minutes'),
    // description: Yup.string().required('Please enter valid Description'),
    discipline: Yup.mixed().required(),
    localDate: Yup.mixed(),
  });

  const getInitialValues = () => ({
    localDate: '',
    patientId: '',
    tasksType: '',
    numberOfMinutes: '',
    // description: '',
    discipline: '',
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: getInitialValues(),
    validationSchema: validationSchema,
    onSubmit: async (values, helpers): Promise<void> => {
      try {
        dispatch(
          addTaskToTherapist({
            providerId,
            data: values,
            isV2: true,
            type: props?.selectedTaskType,
          })
        );
      } catch (err) {
        console.error(err);
      }
    },
  });

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     dispatch(getAllPatientAction());
  //   }, 600);

  //   return () => {
  //     clearTimeout(timer);
  //   };
  // }, [searchName]);

  useEffect(() => {
    dispatch(
      GET_PATIENT_RECORD({
        data: {
          searchString: searchName,
        },
        params: {
          active: true,
          page: pageNo,
          pageSize: 20,
        },
      })
    );
  }, [pageNo, searchName]);

  useEffect(() => {
    dispatch(
      getAllTaskTypeAction({
        providerId,
        active: false,
      })
    );
    formik.setFieldValue('localDate', props.date);
  }, []);

  useEffect(() => {
    if (taskType?.length > 0) {
      formik.setFieldValue('tasksType', 'EVALUATION');
    }
    formik.setFieldValue('discipline', currentTab);
  }, [taskType, currentTab]);

  useEffect(() => {
    if (!isTaskAdded.isTaskAdded && isTaskAdded?.response === null) return;

    if (!isTaskAdded.isGetAvailability && isTaskAdded?.response !== null) {
      setError(isTaskAdded?.response?.message);
      dispatch(resetAddNewTaskTherapist());
      return;
    }
  }, [isTaskAdded]);

  const [allPatients, setAllPatients] = useState<any>([]);

  useEffect(() => {
    if (!Array.isArray(getAllPatients?.content)) return;
    if (pageNo === 0) {
      setAllPatients(getAllPatients?.content);
    } else {
      setAllPatients((prev: any) => [...prev, ...getAllPatients?.content]);
    }
  }, [getAllPatients]);

  const handleScrollCapture = (event: any) => {
    const scrollThreshold = 1;
    if (
      Math.abs(
        (event.target as any).scrollHeight -
          (event.target as any).scrollTop -
          (event.target as any).clientHeight
      ) <= scrollThreshold
    ) {
      // if (!getAllPayerPlan?.response?.data?.last) {
      setPageNo((prev) => prev + 1);
      // }
    }
  };
  return (
    <>
      <form
        noValidate
        onSubmit={formik.handleSubmit}
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="customized-dialog-title"
        >
          <Typography variant="h6">Add New Task</Typography>
        </DialogTitle>
        <Box sx={{ p: 3, width: 600 }}>
          <Grid
            container
            direction={'column'}
            rowSpacing={'20'}
            xs={12}
          >
            <Grid
              xs={12}
              item
            >
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                clearOnBlur={false}
                selectOnFocus={false}
                filterOptions={(x) => x}
                defaultValue={searchDefaultValue}
                options={allPatients}
                getOptionLabel={(option: any) =>
                  option ? `${option?.lastName} ${option?.firstName}` : searchDefaultValue
                }
                ListboxProps={{
                  role: 'closeMenu',
                  style: {
                    maxHeight: '200px',
                  },
                  onScroll: handleScrollCapture,
                }}
                onChange={(event, newValue: any) => {
                  if (newValue === null) {
                    formik.setFieldValue('patientId', '');
                    return;
                  }
                  formik.setFieldValue('patientId', newValue?.uuid);
                }}
                fullWidth
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={!!(formik.touched.patientId && formik.errors.patientId)}
                    helperText={formik.touched.patientId && formik.errors.patientId}
                    label="Patient Name"
                    onChange={(event) => {
                      setPageNo(0);
                      if (intervalTime) clearInterval(intervalTime);
                      let interval = setInterval(() => {
                        setSearchName(event.target.value);
                      }, 600);
                      setIntervalTime(interval);
                    }}
                  />
                )}
                isOptionEqualToValue={(option: any, value: any) => option?.uuid === value?.uuid}
                renderOption={(props, option: any, state) => (
                  <li
                    {...props}
                    key={option?.uuid}
                  >
                    <Box
                      display={'flex'}
                      key={option?.uuid}
                      gap={'5px'}
                    >
                      {`${option?.lastName}, ${option?.firstName}`}
                      <Box
                        sx={{
                          display: !option?.isNonTherapy ? 'none' : 'flex',
                          fontSize: 12,
                          fontWeight: 600,
                          padding: '2px 8px',
                          width: 'max-content',
                          alignItems: 'center',
                          borderRadius: '100px',
                          backgroundColor: 'rgba(38, 45, 47, 0.12)',
                          color: 'rgb(90, 112, 119)',
                        }}
                      >
                        Non Therapy
                      </Box>
                    </Box>
                  </li>
                )}
                popupIcon={
                  gettingPatientList?.loading ? (
                    <CircularProgress
                      color="inherit"
                      size={20}
                    />
                  ) : null
                }
                noOptionsText={
                  gettingPatientList?.loading ? 'Loading... Patient List' : 'No Patient Found'
                }
              />
            </Grid>
            <Grid
              xs={12}
              item
            >
              <TextField
                fullWidth
                label="Task"
                error={!!(formik.touched.tasksType && formik.errors.tasksType)}
                helperText={formik.touched.tasksType && formik.errors.tasksType}
                name="tasksType"
                onBlur={formik.handleBlur}
                value={formik.values.tasksType}
                onChange={(e) => {
                  const trimmedValue = e.target.value;

                  formik.setFieldValue('tasksType', trimmedValue);
                }}
                select
                SelectProps={{ native: true }}
              >
                {taskType?.map(
                  (option: any) =>
                    option.displayName !== 'Therapy' &&
                    option.displayName !== 'Group Therapy' &&
                    option.displayName !== 'Concurrent' && (
                      <option
                        key={option.key}
                        value={option.key}
                      >
                        {option.displayName}
                      </option>
                    )
                )}
              </TextField>
            </Grid>
            <Grid
              xs={12}
              item
            >
              <TextField
                fullWidth
                label="Number of Minutes"
                name="numberOfMinutes"
                error={!!(formik.touched.numberOfMinutes && formik.errors.numberOfMinutes)}
                helperText={formik.touched.numberOfMinutes && formik.errors.numberOfMinutes}
                onBlur={formik.handleBlur}
                value={formik.values.numberOfMinutes}
                onChange={(e) => {
                  const trimmedValue = e.target.value;
                  formik.setFieldValue('numberOfMinutes', trimmedValue);
                }}
              />
            </Grid>
            {error && (
              <FormHelperText
                error
                sx={{ mt: 3 }}
              >
                {error as string}
              </FormHelperText>
            )}
          </Grid>
        </Box>
        <DialogActions>
          <Button
            autoFocus
            onClick={handleCloseAddTaskForm}
          >
            Cancel
          </Button>
          <Button
            autoFocus
            variant="contained"
            type="submit"
            disabled={isTaskAdded?.loading}
          >
            Add
          </Button>
        </DialogActions>
      </form>
    </>
  );
};

export default AddTaskForm;
